import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { OfferListQuery, OfferListVo, PopUpWindowsFlagRequest, PopUpWindowsFlagVo } from './type';

/**
 * offer列表页查询包含（game-service offer + 数字商品offer）
  GET /product/offerManage/queryPageList
  接口ID：252301364
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-252301364
 */
export const getOfferList = (params: OfferListQuery): AxiosPromise<OfferListVo> => {
  return request({
    url: '/product/offerManage/queryPageList',
    method: 'get',
    params
  });
};

// 给卖家提示对应弹窗
// GET /product/offerManage/getPopUpWindowsFlag
// 接口ID：310719171
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-310719171
export const getOfferNoticeInfo = (): AxiosPromise<PopUpWindowsFlagVo> => {
  return request({
    url: '/product/offerManage/getPopUpWindowsFlag',
    method: 'get'
  });
};

// 卖家点击对应弹窗
// POST /product/offerManage/clickPopUpWindows
// 接口ID：310719170
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-310719170
export const postOfferNoticeInfoClick = (data: PopUpWindowsFlagRequest) => {
  return request({
    url: '/product/offerManage/clickPopUpWindows',
    method: 'post',
    data
  });
};
